import TableSortLabel from "@mui/material/TableSortLabel";
import type { TableSortLabelProps } from "@mui/material/TableSortLabel";
import type { JSX } from "react";

/**
 * Заголовок сортируемой колонки как кнопка дизайн-системы: MUI рисует его
 * фокусируемым элементом и сам поднимает нажатие с клавиатуры, а имя примитива
 * прямо говорит, что это управляющий элемент, а не подпись.
 */
export function SortLabelButton(props: TableSortLabelProps): JSX.Element {
  return <TableSortLabel {...props} />;
}
